var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgP22LogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.977 1h6.016V0H1.966v1h4.01zm4.01 1h1.004V1H.963v1h1.003v1H9.988V2zM8.986 4H5.977v1h-4.01V4H.962V3h8.022v1zm-4.01 1H.962v1h1.003v1h4.01V6H4.975V5zm5.013-2h1.003V2h1.002v1h1.003v6H7.982V8h2.006V3zm1.003 5h1.002V7h-1.002v1zM.963 7h4.011v1h1.003v1h-4.01V8H.962V7zm4.011 2H.964v1h4.01V9zM6.98 9h5.013v1H6.98V9zM.963 11v1h1.003v1h4.01v-1h4.012v-1H.963zm4.011 2v1H.964v-1h4.01zm-4.01 2v1h4.01v-1H.964zm4.01 2v1H.964v-1h4.01zM14 2h-1.003v5h1.003V2zM1.966 10v1h9.025v-1H1.966zm0 4v1h4.01v-1h-4.01zm0 3v-1h4.01v1h-4.01z",
    fill: "currentcolor"
  })));
}

export default SvgP22LogoSmall;